const Chip = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {
        fontSzie: "0.875rem",
        // color: "var(--palette-text)",
        background: "var(--palette-default_bg)",
        color: "var(--palette-default)",
        // borderRadius: "5px",
        height: "28px",
      };
    },
    colorPrimary: ({ ownerState, theme }) => ({
      backgroundColor: theme.palette.primary.main,
    }),
    colorSecondary: ({ ownerState, theme }) => ({
      backgroundColor: theme.palette.secondary.main,
    }),
    outlinedPrimary: ({ ownerState, theme }) => {
      return {
        backgroundColor: "transparent",
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      };
    },
    outlinedSecondary: ({ ownerState, theme }) => {
      return {
        backgroundColor: "transparent",
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
      };
    },
    icon: ({ ownerState, theme }) => {
      return { color: theme.palette.custom.text };
    },
    deleteIcon: ({ ownerState, theme }) => {
      return { color: theme.palette.custom.text };
    },
    colorDefault: ({ ownerState, theme }) => {
      // return { backgroundColor: theme.palette.custom.stroke };
    },
    sizeSmall: ({ ownerState, theme }) => {
      return {
        height: "20px",
        // borderRadius: '3px',
      };
    },
  },
};

export default Chip;
